import React from 'react';
import { useMedia } from 'react-use';

import { Feature } from './Feature';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Text } from '../../typography/text/Text';
import styles from './ProductFeatures.module.scss';

const mainCarouselSettings = {
  spaceBetween: 15,
  slidesPerView: 1.2,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  observer: true,
  observeParents: true,
  preloadImages: false,
  navigation: {
    prevEl: '.swiper-left-arrow',
    nextEl: '.swiper-right-arrow',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  lazy: {
    checkInView: true,
    loadPrevNext: true,
    loadPrevNextAmount: 1,
    loadOnTransitionStart: true,
  },
  watchSlidesProgress: true,
};

const ProductFeatures = ({ items, title = 'WHY WE LOVE IT' }) => {
  const isMobile = useMedia('(max-width: 767px)', false);
  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <Text
          className={styles.title}
          as="span"
          weight="normal"
          textTransform="uppercase"
        >
          {title}
        </Text>
      </div>
      <div className={styles.features} style={{ '--features-item-count': items?.length }}>
        {isMobile ? (
          <Swiper {...mainCarouselSettings}>
            {items?.map((item, index) => (
              <SwiperSlide key={`mobile_thumb${index}`}>
                <Feature key={index} item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          items?.map((item, index) => <Feature key={index} item={item} />)
        )}
      </div>
    </div>
  );
};

export default ProductFeatures;
